import { Check, Zap, Package as PackageIcon, Star } from "lucide-react";

const ICONS = {
  level_prestige: <Zap className="h-5 w-5 text-[#ff6b00]" strokeWidth={2.4} />,
  unlock_all: <PackageIcon className="h-5 w-5 text-[#ff6b00]" strokeWidth={2.4} />,
  modded_prestige: <Star className="h-5 w-5 text-[#ff6b00]" strokeWidth={2.4} />,
};

export default function ServiceCard({ packages = [], deliveryMinutes = 5, onSelect }) {
  return (
    <div className="mx-auto max-w-7xl">
      <div className="mb-12 flex items-end justify-between gap-6">
        <div>
          <div className="font-mono-hud text-xs uppercase tracking-[0.4em] text-[#ff6b00]">
            // Loadout Packages
          </div>
          <h2 className="mt-3 font-display text-5xl uppercase tracking-tight text-zinc-100 sm:text-6xl">
            Pick your <span className="text-[#ff6b00]">loadout</span>
          </h2>
          <p className="mt-3 max-w-2xl font-hud text-zinc-400">
            Three tiers. All delivered in ~{deliveryMinutes} minutes via PS4 Testkit once
            your order is picked up.
          </p>
        </div>
        <div className="hidden font-mono-hud text-xs uppercase tracking-widest text-zinc-500 sm:block">
          BO2 · PS4 / PS5
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-3" data-testid="packages-grid">
        {packages.map((pkg) => (
          <PackageCard
            key={pkg.id}
            pkg={pkg}
            icon={ICONS[pkg.id]}
            deliveryMinutes={deliveryMinutes}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}

function PackageCard({ pkg, icon, onSelect }) {
  const featured = pkg.featured;
  return (
    <article
      className={`group relative flex flex-col border bg-[#0a0a0a] transition-colors duration-150 ${
        featured
          ? "border-[#ff6b00] bo2-glow-orange"
          : "border-zinc-800 hover:border-[#ff6b00]/60"
      }`}
      data-testid={`package-${pkg.id}`}
    >
      {featured ? (
        <div className="absolute -top-3 left-4 border border-[#ff6b00] bg-black px-3 py-1 font-mono-hud text-[10px] uppercase tracking-widest text-[#ff6b00]">
          ★ Most Popular
        </div>
      ) : null}

      <header className="flex items-center justify-between border-b border-zinc-900 bg-black px-5 py-3">
        <div className="flex items-center gap-3">
          <div className="grid h-8 w-8 place-items-center border border-[#ff6b00]/50 bg-zinc-950">
            {icon}
          </div>
          <span className="font-mono-hud text-xs uppercase tracking-widest text-zinc-400">
            pkg / <span className="text-[#ff6b00]">{pkg.id.replace("_", "-")}</span>
          </span>
        </div>
      </header>

      <div className="flex flex-1 flex-col p-6 sm:p-7">
        <h3 className="font-display text-2xl uppercase tracking-tight text-zinc-100 sm:text-3xl">
          {pkg.name}
        </h3>
        <p className="mt-2 font-hud text-sm text-zinc-400">{pkg.tagline}</p>

        <div className="mt-6 flex items-baseline gap-2">
          <span className="font-display text-6xl leading-none text-[#ff6b00] bo2-text-glow">
            ${pkg.price}
          </span>
          <span className="font-mono-hud text-xs uppercase tracking-widest text-zinc-500">
            USD · flat
          </span>
        </div>

        <ul className="mt-6 flex-1 space-y-3 border-t border-zinc-900 pt-6">
          {pkg.features.map((f) => (
            <li key={f} className="flex items-start gap-3">
              <span className="mt-1 grid h-4 w-4 flex-none place-items-center border border-[#ff6b00] bg-black">
                <Check className="h-2.5 w-2.5 text-[#ff6b00]" strokeWidth={3.5} />
              </span>
              <span className="font-hud text-sm text-zinc-200">{f}</span>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => onSelect?.(pkg.id)}
          data-testid={`package-cta-${pkg.id}`}
          className={`mt-8 inline-flex w-full items-center justify-center border-2 px-6 py-3 font-display text-base uppercase tracking-widest transition-transform duration-150 hover:-translate-y-1 ${
            featured
              ? "border-[#ff6b00] bg-[#ff6b00] text-black hover:bg-[#ff8125]"
              : "border-[#ff6b00] bg-transparent text-[#ff6b00] hover:bg-[#ff6b00] hover:text-black"
          }`}
        >
          Select — ${pkg.price}
        </button>
      </div>
    </article>
  );
}
